<script setup lang="ts">
import type { HTMLAttributes, Component } from 'vue'

const props = withDefaults(
  defineProps<{
    class?: HTMLAttributes['class']
    text: string
    as?: string | Component
    icon?: string
    viewTransition?: boolean
  }>(),
  {
    as: undefined,
    class: undefined,
    icon: 'lineicons:gemini',
    viewTransition: false
  }
)
</script>
<template>
  <div
    v-if="props.text"
    :class="
      cn(
        'inline-flex items-center gap-2 font-semibold max-lg:text-xxs text-xs px-2 py-1 rounded-full border border-surface-container-high',
        props.class
      )
    "
  >
    <Icon :name="props.icon" class="text-primary" size="20px" />
    <component
      :is="props.as ?? 'h3'"
      :style="
        props.viewTransition ? { viewTransitionName: 'section-subtitle' } : {}
      "
    >
      <span v-html="props.text"></span>
    </component>
  </div>
</template>
